import {
  CBadge,
  CCol,
  CContainer,
  CForm,
  CFormTextarea,
  CRow,
} from "@coreui/react";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./QuizComponent.css";
import postApiCall from "src/server/postApiCall";

function TextAnswerSuperadmin({
  type,
  num,
  question,
  score,
  data,
  onAnswerChange,
  questionID,
  questionTypeID,
  trainingId1,
  assessmentId,
  questionIdCount,
  isCorrect,
}) {
  // Get the default value from the data prop if it exists
  const defaultValue = data?.[0]?.value || "";

  const handleSelectAnswer = (option) => {
    onAnswerChange(questionID, questionTypeID, option);
    addAnswer(option);
  };

  const getClassName = (ans) => {
    if (isCorrect === 1) {
      if (ans?.[0]?.value === 1) {
        return "reviewAnswers";
      }
    } else if (isCorrect === 0) {
      if (ans?.[0]?.value === 1) {
        return "reviewAnswers";
      } else if (ans?.[0]?.value !== ans?.[0]?.userAnswer) {
        return "reviewAnswers2";
      }
    }
    return "";
  };

  const addAnswer = async (value) => {
    const data = {
      trainingId: parseInt(trainingId1),
      assessmentId: parseInt(assessmentId),
      lastAttemptedQuestion: questionIdCount?.length + 1,
      questionId: questionID,
      questionTypeId: questionTypeID,
      answerValue: value,
      finalSubmit: 0,
    };
    try {
      const res = await postApiCall("addAssessmentUserAnswers", data);
      setAssessment_progress_id(res.assessmentProgressId);
    } catch (err) {}
  };

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <CForm>
              <div className="">
                <Typography
                  variant="question"
                  component="div"
                  gutterBottom
                  sx={{ color: "primary.main", mb: 2 }}
                >
                  {`Q${num + 1}. ${question}`}
                </Typography>
                <CCol xs={8}>
                  <CFormTextarea
                    className={getClassName(data)}
                    disabled={type === "3" ? false : true}
                    id="exampleFormControlTextarea1"
                    rows={3}
                    value={type !== "3" ? defaultValue : undefined}
                    onChange={(e) => handleSelectAnswer(e.target.value)}
                  ></CFormTextarea>
                </CCol>
              </div>
            </CForm>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h5>
                <CBadge shape="rounded" color="primary">
                  {score}
                </CBadge>
              </h5>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default TextAnswerSuperadmin;
